module.exports = __webpack_public_path__ + "img/home_news_6.0222171f.png";